import {IRouteChanged, subscribeToRouteChanged} from "../eventBus/route/routeEventBus";
import {appRoutePaths} from "../../config/config";
import playgroundApi from "../playgroundApi";
import {withDisplayErrorToUser} from "../error/error";
import {createCoursesPageViewModel, createInitialCoursesPageViewModel} from "../../factories/coursesPageFactory";
import {createEventBusAndHook} from "../eventBus/common";
import ICoursesPage from "../../models/view/coursesPage/ICoursesPage";
import ICourseCard from "../../models/view/coursesPage/ICourseCard";
import settingsService from "../settings/settingsService";
import {navigate} from "../navigation/navigation";
import {localStorageService} from "../storage/local-storage";
import storageKeys from "../storage/storageKeys";

export const initialCoursesPageViewModel: ICoursesPage = createInitialCoursesPageViewModel();

export const {subscribe: subscribeToCoursesPageViewModelChanged, emitMessage: coursesPageViewModelChanged, use: useCoursesPageViewModel} = createEventBusAndHook<ICoursesPage>(initialCoursesPageViewModel);

class Courses{
  //array of unsubscribe functions to call when this instance is destroyed.
  unsubscribeFuncs: (() => void)[] = [];
  coursesPageViewModel: ICoursesPage = initialCoursesPageViewModel;
  constructor(){
    this.unsubscribeFuncs = [
      subscribeToRouteChanged(this.handleRouteChange.bind(this)),
    ];
  }
  destroy(){
    this.unsubscribeFuncs.forEach(u => u());
  }

  async handleRouteChange({routePath, locationPath, search, userHasValidToken}: IRouteChanged){
    if(appRoutePaths.coursesPage !== routePath || !userHasValidToken){ return this.coursesPageViewModel = initialCoursesPageViewModel; } //reset the model if they leave courses.
    await this.loadCoursesViewModel();
  }

  async loadCoursesViewModel(){
    await withDisplayErrorToUser(async ()=>{
      const myCoursesResponse = await playgroundApi.myCourses();
      if (!myCoursesResponse.categories.length) {throw new Error(`No course section for user could be found.`); }

      //auto display the courses info modal the first time the user visits the page.
      const hasCoursesPageModalBeenDisplayedForTheFirstTime = settingsService.getHasCoursesModalBeenDisplayed();
      settingsService.changeHasCoursesModalBeenDisplayed(true);

      const savedTab = localStorageService.getItem(storageKeys.courses_selectedTab) ?? undefined;
      this.coursesPageViewModel = createCoursesPageViewModel(myCoursesResponse.categories, hasCoursesPageModalBeenDisplayedForTheFirstTime, savedTab);
      coursesPageViewModelChanged(this.coursesPageViewModel);
    });
  }

  displayInfoModal(isVisible: boolean){
    this.coursesPageViewModel = {...this.coursesPageViewModel, isInfoModalVisible: isVisible};
    coursesPageViewModelChanged(this.coursesPageViewModel);
  }

  changeTab(tab: string){
    localStorageService.setItem(storageKeys.courses_selectedTab, tab);
    const hasCoursesPageModalBeenDisplayedForTheFirstTime = settingsService.getHasCoursesModalBeenDisplayed();
    this.coursesPageViewModel = createCoursesPageViewModel(this.coursesPageViewModel.categorizedCourses, hasCoursesPageModalBeenDisplayedForTheFirstTime, tab)
    coursesPageViewModelChanged(this.coursesPageViewModel);
  }
}

export function cardClicked(card: ICourseCard){
  navigate(card.relativeUrl);
}

export function displayInfoModal(isVisible: boolean){
  courses.displayInfoModal(isVisible);
}

export function selectCourseCategoryTab(tab: string){
  courses.changeTab(tab);
}

const courses = new Courses();
export default courses;
